const baseUrl =
  process.env.VUE_APP_MODE === 'production' ? 'https://belirumah.co' : 'https://belirumah.co';
import Cookie from 'cookie';
import Cookies from 'js-cookie';
import {
  deleteForUser,
  forgetLastUserUuid,
  getLastUserUuid,
  rememberLastUserUuid,
} from '@/services/listingDraftRepository';
const apiUrl =
  process.env.VUE_APP_MODE === 'production'
    ? process.env.VUE_APP_PROD_API_URL
    : process.env.VUE_APP_LOCAL_API_URL;
const tinyApiKey = 'vw6rtoplvvfhhm3sakon863c7jprmrpggmsl4l0hstbac4mm';
const logoUrl =
  'https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/logo/v2/logo-agen.svg';
const logoUserUrl =
  'https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/logo/v2/logo.svg';

export const state = () => ({
  loggedIn: false,
  user: null,
  baseUrl: baseUrl,
  apiUrl: apiUrl,
  logoUrl: logoUrl,
  logoUserUrl: logoUserUrl,
  headerLayout: null,
  tinyApiKey: tinyApiKey,
  message: null,
  messageType: null,
  galleryHeight: 0,
  bodyClass: 'booking',
  bodyId: 'content',
  modalMask: false,
  closeModal: false,
  projectFormMode: false,
  buttonDisabled: false,
  refreshData: false,
  rows: [],
  locale: 'id',
  token: null,
  isLoading: false,
  locales: [
    {
      id: 'id',
      name: 'Bahasa Indonesia',
    },
  ],
  mainSidebar: false,
  sidebarContent: null,
  showFooter: true,
  openFooter: false,
  remember: false,
  mobileWebView: false,
  // allowedAddSellIds: [41, 45, 291], // kalau isi null, semua bisa add
  allowedAddSellIds: null, // kalau isi null, semua bisa add
  allowed360EmbedIds: null, // kalau isi null, semua bisa add
  allowedProjectDiscountIds: [
    99999999999,
    // 2558,
  ], // kalau isi null, semua bisa add
  allowedDiscountUserHashIds: [],
  allowedDiscountProjectPartner: ['urbanspace'],
  membershipAction: null,
  enquiriesUnreadCount: 0,
  enableRecommendedListing: true, // The switch to enable all recommended listing features
  enableCoinTransfer: true, // The switch to enable all coin transfer features
  // ponytail: one rollout flag keeps the existing coin card as the fallback.
  enableCoinPromoCard: false,
});
export const getters = {
  allowAddSellProject(state, getters, rootState) {
    if (!rootState.global.user) return false;
    if (rootState.global.allowedAddSellIds === null) return true;
    if (rootState.global.allowedAddSellIds.length === 0) return false;
    return rootState.global.allowedAddSellIds.includes(rootState.global.user.id);
  },
  allow360EmbedProject(state, getters, rootState) {
    if (!rootState.global.user) return false;
    if (rootState.global.allowed360EmbedIds === null) return true;
    if (rootState.global.allowed360EmbedIds.length === 0) return false;
    return rootState.global.allowed360EmbedIds.includes(rootState.global.user.id);
  },
  allowProjectDiscount(state, getters, rootState) {
    if (!rootState.global.user) return false;
    if (rootState.global.allowedProjectDiscountIds === null) return true;
    if (rootState.global.allowedProjectDiscountIds.length === 0) return false;
    return rootState.global.allowedProjectDiscountIds.includes(rootState.global.user.id);
  },
  getLocaleName: (state) => {
    const item = state.locales.find(function (item) {
      return item.id === state.locale;
    });
    return item ? item.name : null;
  },
  // eslint-disable-next-line no-unused-vars
  isModalShown: (state, getters) => (modalName) => {
    const selectedModal = state.modals.find(function (modal) {
      return modal.name === modalName;
    });
    return selectedModal.show;
  },
  // eslint-disable-next-line no-unused-vars
  getModalData: (state, getters) => (modalName) => {
    const selectedModal = state.modals.find(function (modal) {
      return modal.name === modalName;
    });
    return selectedModal.data;
  },
  // activeIds(state, getters, rootState) {
  //   const {activeType, itemsPerPage, lists} = state
  //
  //   if (!activeType) {
  //     return []
  //   }
  //
  //   // const page = 1
  //   const page = Number(rootState.route.params.page) || 1
  //   const start = (page - 1) * itemsPerPage
  //   const end = page * itemsPerPage
  //
  //   return lists[activeType].slice(start, end)
  // },
  //
  // activeItems(state, getters) {
  //   return getters.activeIds.map(id => state.items[id]).filter(_ => _)
  // },
  // eslint-disable-next-line no-unused-vars
  getHeaderHeight: (state, getters) => (modalName) => {
    return state.headerLayout ? state.headerLayout.clientHeight : 96;
  },
  membershipType(state) {
    let type = state.user && state.user.membership ? state.user.membership.type : '';
    if (type === 'SILVER') type = 'STARTER';
    if (type === 'GOLD') type = 'PRO';
    if (type === 'PLATINUM') type = 'EXECUTIVE';
    return type;
  },
  isProOrExecutive(state, getters) {
    return ['PRO', 'EXECUTIVE'].includes(getters.membershipType);
  },
  isAgenNaikKelas(state) {
    if (!state.user) return false;

    const directFlag = state.user.agent_naik_kelas_badge;

    if (typeof directFlag === 'boolean') return directFlag;
    if (typeof directFlag === 'number') return directFlag === 1;
    if (typeof directFlag === 'string') {
      const normalized = directFlag.trim().toLowerCase();
      return normalized === '1' || normalized === 'true' || normalized === 'yes';
    }

    return false;
  },
};
export const mutations = {
  SET_LANG(state, locale) {
    const lang = state.locales.find(function (el) {
      return el.id === locale;
    });
    if (lang !== undefined) {
      state.locale = locale;
      Cookies.set('locale', locale);
    }
  },
  SET_BUTTON_DISABLED(state, payload) {
    state.buttonDisabled = payload;
  },

  SET_TIME_ZONE(state, payload) {
    state.timeZone = payload;
  },
  SET_ENQUIRIES_UNREAD_COUNT(state, payload) {
    state.enquiriesUnreadCount = payload;
  },
  SET_REFRESH_DATA(state, payload) {
    state.refreshData = payload;
  },
  SET_BODY_CLASS(state, payload) {
    state.bodyClass = payload;
  },
  SET_BODY_ID(state, payload) {
    state.bodyId = payload;
  },
  SET_MODAL_MASK(state, payload) {
    state.modalMask = payload;
  },
  SET_PROJECT_FORM(state, payload) {
    state.projectFormMode = payload;
  },
  SHOW_MODAL(state, payload) {
    state.modalMask = true;
    const modalName = payload.modalName;
    const modalData = payload.data;
    state.modals.forEach(function (modalData_) {
      if (modalData_.name == modalName) {
        modalData_.show = true;
        modalData_.data = modalData;
      }
    });
  },
  SET_CLOSE_MODAL(state, payload) {
    state.closeModal = payload;
    state.modalMask = false;
  },
  CLOSE_MODAL(state, modalName) {
    state.closeModal = true;
    state.modalMask = false;
    state.modals.forEach(function (modal) {
      if (modal.name == modalName) {
        modal.show = false;
        modal.data = null;
      }
    });
  },
  SET_ALERT_MESSAGE(state, payload) {
    state.message = payload.message;
    state.messageType = payload.messageType;
  },
  RESET_ALERT(state) {
    state.messageType = null;
    state.message = null;
  },
  SET_GALLERY_HEIGHT(state, payload) {
    state.galleryHeight = payload;
  },

  SET_SHOW_FOOTER_MOBILE(state, payload) {
    state.openFooter = payload;
  },
  SET_SHOW_FOOTER(state, payload) {
    state.showFooter = payload;
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },

  SET_REMEMBER(state, remember) {
    state.remember = remember;
  },
  SET_TOKEN(state, payload) {
    state.token = payload;
  },
  SET_USER(state, user) {
    state.user = user;
    state.loggedIn = !!user;
    if (user && user.uuid) rememberLastUserUuid(user.uuid);
  },
  SET_ROWS(state, rows) {
    state.rows = rows;
  },
  SET_LOCALE(state, payload) {
    if (state.locales.includes(payload)) {
      state.locale = payload;
    }
  },
  SET_MAIN_SIDEBAR(state, payload) {
    state.mainSidebar = payload;
  },
  SET_SIDEBAR_CONTENT(state, payload) {
    state.sidebarContent = payload;
  },
  set_user_input(state, user) {
    state.user = Object.assign({}, state.user, user);
  },
  SET_MOBILE_WEB_VIEW(state, payload) {
    state.mobileWebView = payload;
  },
  SET_HEADER_LAYOUT(state, payload) {
    state.headerLayout = payload;
  },
  SET_MEMBERSHIP_ACTION(state, payload) {
    state.membershipAction = payload;
  },
};

export const actions = {
  // eslint-disable-next-line
  async contactEnquiry({ commit }, requestData) {
    return await this.$http.post('/api/v2/contact/enquiry', requestData).then((result) => {
      return result.data;
    });
  },

  // eslint-disable-next-line
  async uploadPhoto({ commit }, requestData) {
    return await this.$http.post('/api/file_content/upload_photo', requestData).then((result) => {
      console.log('UPLOAD PHOTO: ', result.data.data.photo_uuid);
      return result.data.data.photo_uuid;
    });
  },

  // eslint-disable-next-line
  async agentPartner({ commit }, requestData) {
    return await this.$http.post('/api/registration/agent/submit', requestData).then((result) => {
      return result.data;
    });
  },

  // eslint-disable-next-line
  async developerPartner({ commit }, requestData) {
    return await this.$http.post('/api/registration/project/submit', requestData).then((result) => {
      return result.data;
    });
  },

  // eslint-disable-next-line
  async helpFindResidence({ commit }, requestData) {
    return await this.$http
      .post('/api/find_project_inquiries/submit', requestData)
      .then((result) => {
        return result.data;
      });
  },

  async fetchRows({ commit }) {
    const { data } = await this.$http.get('/api/public');
    commit('SET_ROWS', data);
  },

  // eslint-disable-next-line no-empty-pattern
  async accountActivation({}, token) {
    try {
      const response = await this.$http.get('/api/auth/email_activation/' + token);

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  // eslint-disable-next-line no-empty-pattern
  async updatePhoneSendOtp({ dispatch }, { phone }) {
    try {
      let data = await this.$http.post('/api/user_verify/update_phone_send_otp', {
        phone_number: phone,
      });
      await dispatch('fetch');
      return data.data;
    } catch (e) {
      throw e;
    }
  },

  // eslint-disable-next-line no-empty-pattern
  async verifyOtp({}, { otp }) {
    try {
      let data = await this.$http.post('/api/user_verify/verify_otp', {
        otp: otp,
      });
      return data.data;
    } catch (e) {
      throw e;
    }
  },

  // eslint-disable-next-line no-empty-pattern
  async sendOtp({}, { phone, captchaToken }) {
    try {
      let data = await this.$http.post('/api/otp/request_new', {
        phone_number: phone,
        'cf-turnstile-response': captchaToken,
      });
      return data.data;
    } catch (e) {
      throw e;
    }
  },

  async login({ commit, dispatch }, { fields, endpoint = '/api/agent/auth/login' } = {}) {
    // Send credentials to API
    let data = await this.$http.post(endpoint, fields);

    commit('SET_REMEMBER', fields.remember);

    await dispatch('updateToken', data.data.token);

    await dispatch('fetch');

    return data.data;
  },

  async convertToAgent({ dispatch }, { fields, endpoint = '/api/agent/auth/login/convert' } = {}) {
    // Send credentials to API
    let data = await this.$http.post(endpoint, fields);
    await dispatch('updateToken', data.data.token);
    await dispatch('fetch');
    return data.data;
  },

  async updateToken({ state, commit }, token) {
    const validToken = token && token !== 'null' && token !== 'undefined';
    // Update token in store's state
    commit('SET_TOKEN', validToken ? token : null);

    // $http.setToken(token, 'Bearer');
    if (validToken) {
      this.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      delete this.$http.defaults.headers.common.Authorization;
    }

    if (process.browser) {
      // ...Browser
      if (validToken) {
        Cookies.set('BeliRumaAgentApp', token, {
          expires: state.remember ? 365 : null,
        });
      } else {
        Cookies.remove('BeliRumaAgentApp');
      }
    }
  },
  // eslint-disable-next-line no-unused-vars
  async registerUser({ commit }, formData) {
    return await this.$http.post('/api/agent/auth/register', formData);
  },

  async checkEmail({ commit }, email) {
    commit('SET_LOADING', true);
    const data = await this.$http.get('/api/auth/check_email_exist?email=' + email);
    commit('SET_LOADING', false);
    return data.data;
  },

  async changePhone({ commit, dispatch }, { phone, otp }) {
    commit('SET_LOADING', true);

    try {
      let data = await this.$http.post('/api/profile/phone_number', {
        phone_number: phone,
        otp: otp,
      });

      await dispatch('fetch');

      return data.data;
    } catch (e) {
      console.log('ERROR UPDATE USER EMAIL: ', e);
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetch({ state, commit, dispatch }, { endpoint = '/api/user-agent' } = {}) {
    await dispatch('fetchToken');
    // Skip if there is no token set
    if (!state.token) {
      return;
    }
    // Try to get user profile
    try {
      const data = await this.$http.get(endpoint);
      commit('SET_USER', data.data.data);
      Cookies.set('user', JSON.parse(JSON.stringify(data.data.data)));
      dispatch('getEnquiriesUnreadCount');
    } catch (e) {
      await dispatch('resetAuth');
    }
  },

  async resetAuth({ state, dispatch, commit }) {
    const userUuid = (state.user && state.user.uuid) || getLastUserUuid();
    commit('listingForm/SET_LOCAL_DRAFT_READY', false, { root: true });
    if (userUuid) {
      try {
        await deleteForUser(userUuid);
      } catch (error) {
        console.error('Failed to delete listing draft during auth reset:', error);
      }
    }
    forgetLastUserUuid();
    commit('SET_USER', null);
    await dispatch('updateToken', null);
  },

  async fetchToken({ dispatch }) {
    let token;

    const cookieStr = process.browser ? document.cookie : null;
    const cookies = Cookie.parse(cookieStr || '') || {};
    token = cookies.BeliRumaAgentApp;
    if (token && token !== 'null' && token !== 'undefined') {
      await dispatch('updateToken', token);
    }
  },

  // Simple action to logout current user
  // async logout({ commit }) {
  //   if (process.client) {
  //     require('js-cookie').set('token', null, { path: '/' });
  //   }
  //   commit('SET_USER', {enquiriesUnreadCount
  //     username: null,
  //     logged: false,
  //   });
  // },
  async logout({ dispatch }, { endpoint = '/api/auth/logout' } = {}) {
    // Server side logout
    try {
      await this.$http.post(endpoint);
      Cookies.remove('belirumaAgentTakeover');
    } catch (e) {
      // console.error('Error while logging out', e)
    }
    // Reset store
    await dispatch('resetAuth');
  },
  // eslint-disable-next-line no-empty-pattern
  async forgotPassword({}, formData) {
    const data = await this.$http.post('/api/auth/forgot-password', formData);
    return data;
  },
  // eslint-disable-next-line no-empty-pattern
  async resetPassword({}, fieldData) {
    try {
      let response = await this.$http.post('/api/auth/reset-password', fieldData);

      return response.data;
    } catch (e) {
      throw e;
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async submitConsultation({}, formData) {
    return await this.$http.post('/api/contact/consultation', formData);
  },

  async getMembershipAction({ commit }) {
    try {
      let data = await this.$http.get('/api/memberships/actions');
      commit('SET_MEMBERSHIP_ACTION', data.data.data);
      return data.data.data;
    } catch (e) {
      throw e;
    }
  },
  async getEnquiriesUnreadCount({ commit }) {
    try {
      let data = await this.$http.get('/api/enquiries/unread_count');
      commit('SET_ENQUIRIES_UNREAD_COUNT', data.data.data);
      return data.data.data;
      // eslint-disable-next-line no-empty
    } catch (e) {}
  },
};
